import { network } from 'services/network';

export const createOrUpdateReportComment = (params) => {
    return network.post('api/bo/reporting/createOrUpdateReportComment', params).then((response) => {
        return response.data;
    });
};
